export const homeTranslations = {
  onboarding: {
    title: {
      key: 'home.onboarding.title',
      defaultValue: 'Back Office Onboarding',
    },
    subTitle: {
      key: 'home.onboarding.subTitle',
      defaultValue: 'Follow the steps and get to know Back office',
    },
    complete: {
      key: 'home.onboarding.complete',
      defaultValue: 'Onboarding completed!',
    },
  },
  storeOverview: {
    key: 'home.storeOverview',
    defaultValue: 'Store Overview',
  },
  common: {
    forecastTileTooltip: {
      key: 'home.common.metricTileTooltip.forecastTile',
      defaultValue: 'Projected achievement against target by the end of today based on current performance.',
    },
    error: {
      key: 'home.common.error',
      defaultValue: 'Error',
    },
    noData: {
      key: 'home.common.nodata',
      defaultValue: 'No transaction has been made yet.',
    },
    count: {
      key: 'home.common.count',
      defaultValue: 'Count',
    },
    type: {
      key: 'home.common.type',
      defaultValue: 'Type',
    },
    dateBasedData: {
      key: 'home.common.dateBasedData',
      defaultValue: 'Data based on:',
    },
    noReceipts: {
      key: 'home.common.noReceipts',
      defaultValue: 'No receipts have been created yet.',
    },
    noSCOReceipts: {
      key: 'home.common.noSCOReceipts',
      defaultValue: 'No SCO receipts have been created yet.',
    },
    noWeeklyData: {
      key: 'home.common.noWeeklyData',
      defaultValue: 'No weekly data available for this widget',
    },
    noMonthlyData: {
      key: 'home.common.noMonthlyData',
      defaultValue: 'No monthly data available for this widget',
    },
    loading: {
      key: 'home.common.loading',
      defaultValue: 'Loading',
    },
    targetKPINewMember: {
      key: 'home.common.targetKPINewMember',
      defaultValue: 'Target KPI New Member: ',
    },
    targetKPIHourly: {
      key: 'home.common.targetKPIHourly',
      defaultValue: 'Target KPI Net Sales: ',
    },
    targetKPISCOHourly: {
      key: 'home.common.targetKPISCOHourly',
      defaultValue: 'Target KPI SCO Net Sales: ',
    },
    targetKPICR: {
      key: 'home.common.targetKPICR',
      defaultValue: 'Target KPI for CR: ',
    },
    targetKPINMShare: {
      key: 'home.common.targetKPINMShare',
      defaultValue: 'Target KPI NM Share: ',
    },
    targetKPISOR: {
      key: 'home.common.targetKPISOR',
      defaultValue: 'Target KPI SOR: ',
    },
    targetKPISCOSOR: {
      key: 'home.common.targetKPISCOSOR',
      defaultValue: 'Target KPI SCO SOR: ',
    },
    targetKPIQueueLength: {
      key: 'home.common.targetKPIQueueLength',
      defaultValue: 'Target KPI Queue Length: ',
    },
    allTabName: {
      key: 'home.common.allTabName',
      defaultValue: 'All',
    },
    today: {
      key: 'home.common.today',
      defaultValue: 'Today',
    },
    yesterday: {
      key: 'home.common.yesterday',
      defaultValue: 'Yesterday',
    },
    lastWeek: {
      key: 'home.common.lastWeek',
      defaultValue: 'Last Week',
    },
    lastYear: {
      key: 'home.common.lastYear',
      defaultValue: 'Last Year',
    },
    thanActual: {
      key: 'home.common.thanActual',
      defaultValue: 'than Actual',
    },
    thanBudget: {
      key: 'home.common.thanBudget',
      defaultValue: 'vs Budget',
    },
    thanPlanned: {
      key: 'home.common.thanPlanned',
      defaultValue: 'vs Plan',
    },
    nearby: {
      key: 'home.common.nearby',
      defaultValue: 'Nearby',
    },
    expandAll: {
      key: 'home.common.expandAll',
      defaultValue: 'Expand All',
    },
    collapseAll: {
      key: 'home.common.collapseAll',
      defaultValue: 'Collapse All',
    },
    forecast: {
      key: 'home.common.forecast',
      defaultValue: 'Forecast',
    },
    progress: {
      key: 'home.common.progress',
      defaultValue: 'Progress',
    },
    hourlyTarget: {
      key: 'home.common.hourlyTarget',
      defaultValue: 'Hourly Target',
    },
    showAreaSwitch: {
      key: 'home.common.showAreaSwitch',
      defaultValue: 'Show Area Widget',
    },
    hideAreaSwitch: {
      key: 'home.common.hideAreaSwitch',
      defaultValue: 'Hide Area Widget',
    },
    lastUpdated: {
      key: 'home.common.lastUpdated',
      defaultValue: 'Last Updated',
    },
    overview: {
      key: 'home.common.overview',
      defaultValue: 'Overview',
    },
    changeVsCurrentNote: {
      key: 'home.common.changeVsCurrentNote',
      defaultValue: ' (change vs current %)',
    },
    timeUnit: {
      key: 'common.timeUnit',
      defaultValue: 'Time Unit',
    },
  },
  datePicker: {
    weekLabel: {
      key: 'home.common.datePicker.weekLabel',
      defaultValue: 'Week',
    },
    radioLabel1: {
      key: 'home.common.datePicker.radioLabel1',
      defaultValue: 'Select a Date',
    },
    radioLabel2: {
      key: 'home.common.datePicker.radioLabel2',
      defaultValue: 'Select a Week',
    },
    radioLabel3: {
      key: 'home.common.datePicker.radioLabel3',
      defaultValue: 'Select a Month',
    },
    radioLabel4: {
      key: 'home.common.datePicker.radioLabel4',
      defaultValue: 'Select a Range',
    },
  },
  banners: {
    translationError: {
      key: 'home.banners.translationError',
      defaultValue: 'We are facing some troubles translating to your desired language.',
    },
    onBoardingSuccess: {
      key: 'home.banners.onBoardingSuccess',
      defaultValue:
        'Nice work, you have just completed an onboarding item! Visit the onboarding list on the home screen to view your progress.',
    },
    serviceAlerts: {
      key: 'home.banners.serviceAlerts',
      defaultValue: 'We are sorry, but due to some technical issues, some of the data is not updated.',
    },
    offline: {
      key: 'home.banners.offline',
      defaultValue: 'You’re offline. The data might not be up to date. Check your internet and try again.',
    },
  },
  slider: {
    generalInformation: {
      key: 'home.slider.generalInformation',
      defaultValue: 'General Information',
    },
    storeOpeningHours: {
      key: 'home.slider.storeOpeningHours',
      defaultValue: 'Opening hours',
    },
    storeOpeningHoursError: {
      key: 'home.slider.storeOpeningHoursError',
      defaultValue: 'Store opening hours information is currently unavailable.',
    },
    chatBotPlaceholder: {
      key: 'home.slider.chatBotPlaceholder',
      defaultValue: 'Ask a question',
    },
    chatbotFailureText: {
      key: 'home.slider.chatbotFailureText',
      defaultValue: 'Sorry, the chatbot is currently unavailable. Please try again later.',
    },
    weatherFailureText: {
      key: 'home.slider.weatherFailureText',
      defaultValue: 'Weather information is currently unavailable.',
    },
  },
  budgetPlanned: {
    title: {
      key: 'home.budgetPlanned.title',
      defaultValue: 'Budget and Plan',
    },
    budget: {
      key: 'home.budgetPlanned.budget',
      defaultValue: 'Budget',
    },
    planned: {
      key: 'home.budgetPlanned.planned',
      defaultValue: 'Plan',
    },
    budgetDropdown: {
      key: 'home.budgetPlanned.budgetDropdown',
      defaultValue: 'Show Budget/Plan',
    },
    error: {
      key: 'home.budgetPlanned.error',
      defaultValue: 'Something went wrong!',
    },
    noPermissionBudgetTooltip: {
      key: 'home.budgetPlanned.noPermissionBudgetTooltip',
      defaultValue: 'You do not have permission to view Budget/Plan',
    },
    currentText: {
      key: 'home.budgetPlanned.currentText',
      defaultValue: 'Current',
    },
    differenceText: {
      key: 'home.budgetPlanned.differenceText',
      defaultValue: 'Difference',
    },
    indexText: {
      key: 'home.budgetPlanned.indexText',
      defaultValue: 'Index',
    },
    trendText: {
      key: 'home.budgetPlanned.trendText',
      defaultValue: 'Trend',
    },
    noBudgetDataText: {
      key: 'home.budgetPlanned.noBudgetDataText',
      defaultValue: 'No budget data found!',
    },
    noPlannedDataText: {
      key: 'home.budgetPlanned.noPlannedDataText',
      defaultValue: 'No plan data found!',
    },
    budgetTooltip: {
      key: 'home.budgetPlanned.budgetTooltip',
      defaultValue:
        'Budget: Target value allocated for the selected period. Plan: Expected value planned for the selected period. Difference: Difference between the current value and the budget or plan value. Index: Takt calculated relative to budget or plan value. Trend: Percentage above or below the budget or plan value.',
    },
  },
  hourlyTurnover: {
    title: {
      key: 'home.hourlyTurnover.title',
      defaultValue: 'Sales Net',
    },
    subTitle: {
      key: 'home.hourlyTurnover.subTitle',
      defaultValue: 'Hourly net sales',
    },
    error: {
      key: 'home.hourlyTurnover.error',
      defaultValue: 'We can´t show the sales net widget right now.',
    },
    totalSales: {
      key: 'home.hourlyTurnover.totalSales',
      defaultValue: 'Total Sales',
    },
    toolTip: {
      key: 'home.hourlyTurnover.toolTip',
      defaultValue: 'Hourly net sales in store',
    },
    addKpiSalesNet: {
      key: 'home.hourlyTurnover.addKpiSalesNet',
      defaultValue: 'Add KPI for Sales Net',
    },
    editKpiSalesNet: {
      key: 'home.hourlyTurnover.editKpiSalesNet',
      defaultValue: 'Edit KPI for Sales Net',
    },
    addKpiSCOSalesNet: {
      key: 'home.hourlyTurnover.addKpiSCOSalesNet',
      defaultValue: 'Add KPI for SCO Sales Net',
    },
    editKpiSCOSalesNet: {
      key: 'home.hourlyTurnover.editKpiSCOSalesNet',
      defaultValue: 'Edit KPI for SCO Sales Net',
    },
    metricTileTooltip: {
      totalSalesTile: {
        key: 'home.hourlyTurnover.metricTileTooltip.totalSalesTile',
        defaultValue: 'Total sales net for selected period',
      },
      targetTile: {
        key: 'home.hourlyTurnover.metricTileTooltip.targetTile',
        defaultValue: 'Target for net sale for selected period',
      },
      lastWeekTile: {
        key: 'home.hourlyTurnover.metricTileTooltip.lastWeekTile',
        defaultValue: 'Net sales during the same period last week.{{changeNote}}',
      },
      lastYearTile: {
        key: 'home.hourlyTurnover.metricTileTooltip.lastYearTile',
        defaultValue: 'Net sales during the same period last year.{{changeNote}}',
      },
    },
    tabs: {
      regularSales: { key: 'home.hourlyTurnover.tabs.regularSales', defaultValue: 'Regular Sales' },
      scoSales: { key: 'home.hourlyTurnover.tabs.scoSales', defaultValue: 'SCO Sales' },
      rfidScoSales: { key: 'home.hourlyTurnover.tabs.rfidScoSales', defaultValue: 'RFID SCO Sales' },
      mobileSales: { key: 'home.hourlyTurnover.tabs.mobileSales', defaultValue: 'Mobile Sales' },
    },
  },
  conversionRate: {
    title: {
      key: 'home.conversionRate.title',
      defaultValue: 'Conversion rate',
    },
    subTitle: {
      key: 'home.conversionRate.subTitle',
      defaultValue: 'The amount of non paying & paying customers.',
    },
    error: {
      key: 'home.conversionRate.error',
      defaultValue: 'We can´t show the conversion widget right now.',
    },
    average: {
      key: 'home.conversionRate.average',
      defaultValue: 'Average',
    },
    totalVisitors: {
      key: 'home.conversionRate.totalVisitors',
      defaultValue: 'Total Visitors',
    },
    numberOfTills: {
      key: 'home.conversionRate.numberOfTills',
      defaultValue: 'Utilized Tills',
    },
    payingCustomers: {
      key: 'home.conversionRate.payingCustomers',
      defaultValue: 'Paying',
    },
    nonPayingCustomers: {
      key: 'home.conversionRate.nonPayingCustomers',
      defaultValue: 'Non Paying',
    },
    toolTip: {
      key: 'home.conversionRate.toolTip',
      defaultValue:
        'Quick overview of number of paying vs non-paying customers. The Forecast is shown in percentage. \n\nNOTE: Expect 1-2 hours delay for visitor data to show',
    },
    visitors: {
      key: 'home.conversionRate.visitors',
      defaultValue: 'Visitors',
    },
    noVisitors: {
      key: 'home.conversionRate.noVisitors',
      defaultValue: 'No visitors data available.',
    },
    metricTileTooltip: {
      conversionRateTile: {
        key: 'home.conversionRate.metricTileTooltip.conversionRateTile',
        defaultValue: 'Conversion Rate for selected period',
      },
      targetTile: {
        key: 'home.conversionRate.metricTileTooltip.targetTile',
        defaultValue: 'Target for conversion rate for selected period',
      },
      lastWeekTile: {
        key: 'home.conversionRate.metricTileTooltip.lastWeekTile',
        defaultValue: 'Conversion Rate during the same period last week.{{changeNote}}',
      },
      lastYearTile: {
        key: 'home.conversionRate.metricTileTooltip.lastYearTile',
        defaultValue: 'Conversion Rate during the same period last year.{{changeNote}}',
      },
      totalVisitorsTile: {
        key: 'home.conversionRate.metricTileTooltip.totalVisitorsTile',
        defaultValue: 'Total number of visitors for selected period',
      },
      payingCustomersTile: {
        key: 'home.conversionRate.metricTileTooltip.payingCustomersTile',
        defaultValue: 'Total number of visitors who completed a paid conversion for selected period',
      },
      nonPayingCustomersTile: {
        key: 'home.conversionRate.metricTileTooltip.nonPayingCustomersTile',
        defaultValue: 'Total number of visitors who did not complete a paid conversion for selected period',
      },
    },
  },
  salesNet: {
    title: {
      key: 'home.salesNet.title',
      defaultValue: 'Sales',
    },
    subTitle: {
      key: 'home.salesNet.subTitle',
      defaultValue: 'Weekly Net sales in store',
    },
    error: {
      key: 'home.salesNet.error',
      defaultValue: 'We can´t show the sales widget right now.',
    },
    weekly: {
      key: 'home.salesNet.weekly',
      defaultValue: 'Weekly',
    },
    actual: {
      key: 'home.salesNet.actual',
      defaultValue: 'Actual',
    },
    toolTip: {
      key: 'home.salesNet.toolTip',
      defaultValue: 'Net Sales in store for the past week. The Forecast is shown in currency.',
    },
  },
  topSelling: {
    title: {
      key: 'home.topSelling.title',
      defaultValue: 'Top selling garment',
    },
    subTitle: {
      key: 'home.topSelling.subTitle',
      defaultValue: 'In the store right now',
    },
    error: {
      key: 'home.topSelling.error',
      defaultValue: 'We can´t show the top selling garment widget right now.',
    },
    toolTip: {
      key: 'home.topSelling.toolTip',
      defaultValue: 'Top Selling Garments sold in the store',
    },
  },
  orisCustomers: {
    title: {
      key: 'home.orisCustomers.title',
      defaultValue: 'ORIS',
    },
    subTitle: {
      key: 'home.orisCustomers.subTitle',
      defaultValue: 'Online Return in Store',
    },
    error: {
      key: 'home.orisCustomers.error',
      defaultValue: 'We can´t show the top returns garment widget right now.',
    },
    toolTip: {
      key: 'home.orisCustomers.toolTip',
      defaultValue:
        'Tracks the efficiency of processing online returns in-store, customer conversions, loyalty member participation, and time taken.',
    },
    orisConversionRate: {
      text: {
        key: 'home.orisCustomers.orisConversionRate.text',
        defaultValue: 'ORIS Conversion Rate',
      },
      tooltip: {
        key: 'home.orisCustomers.orisConversionRate.tooltip',
        defaultValue:
          'This represents the percentage of online returns that are successfully converted into new purchases or exchanges during the visit.',
      },
    },
    orisTotalTransactions: {
      text: {
        key: 'home.orisCustomers.orisTotalTransactions.text',
        defaultValue: 'Total Transactions',
      },
      tooltip: {
        key: 'home.orisCustomers.orisTotalTransactions.tooltip',
        defaultValue:
          'The total number of online returns processed in-store, indicating the overall volume of returns handled.',
      },
    },
    orisConvertedTransactions: {
      text: {
        key: 'home.orisCustomers.orisConvertedTransactions.text',
        defaultValue: 'Converted Transactions',
      },
      tooltip: {
        key: 'home.orisCustomers.orisConvertedTransactions.tooltip',
        defaultValue:
          'This measures how many online returns were converted into sales, reflecting successful upselling or exchanges.',
      },
    },
    orisTotalLoyaltyTransactions: {
      text: {
        key: 'home.orisCustomers.orisTotalLoyaltyTransactions.text',
        defaultValue: 'Total Loyalty Transactions',
      },
      tooltip: {
        key: 'home.orisCustomers.orisTotalLoyaltyTransactions.tooltip',
        defaultValue:
          'The total number of returns made by loyalty program members, indicating engagement from frequent customers.',
      },
    },
    averageOrisTime: {
      text: {
        key: 'home.orisCustomers.averageOrisTime.text',
        defaultValue: 'Average Time',
      },
      tooltip: {
        key: 'home.orisCustomers.averageOrisTime.tooltip',
        defaultValue:
          'The average time taken to process each online return in-store, including any additional purchases or exchanges',
      },
    },
    duration: {
      seconds: {
        key: 'home.orisCustomers.duration.seconds',
        defaultValue: 'seconds',
      },
      minutes: {
        key: 'home.orisCustomers.duration.minutes',
        defaultValue: 'minutes',
      },
      hours: {
        key: 'home.orisCustomers.duration.hours',
        defaultValue: 'hours',
      },
    },
  },
  newMembers: {
    title: {
      key: 'home.newMembers.title',
      defaultValue: 'New Members',
    },
    subTitle: {
      key: 'home.newMembers.subTitle',
      defaultValue: 'New H&M Member Recruited',
    },
    error: {
      key: 'home.newMembers.error',
      defaultValue: 'We can´t show the new members widget right now.',
    },
    toolTip: {
      key: 'home.newMembers.toolTip',
      defaultValue: 'Hourly view of New Members in store. The Forecast is shown in numbers',
    },
    totalNewMembers: {
      key: 'home.newMembers.totalNewMembers',
      defaultValue: 'Total New Members',
    },
    totalNMShare: {
      key: 'home.newMembers.totalNMShare',
      defaultValue: 'Total New Member Share',
    },
    unrecruited: {
      key: 'home.newMembers.unrecruited',
      defaultValue: 'Total Unrecruited',
    },
    recruitedTooltip: {
      key: 'home.newMembers.recruitedTooltip',
      defaultValue: 'All new members recruited and they should have made a purchase the same day.',
    },
    unRecruitedTooltip: {
      key: 'home.newMembers.unRecruitedTooltip',
      defaultValue: 'All customers that made a purchase without registering as a member. ',
    },
    recruitedShareTooltip: {
      key: 'home.newMembers.recruitedShareTooltip',
      defaultValue:
        'Percentage of new members who signed up and purchased the same day out of all non‑returned transactions.',
    },
    metricTileTooltip: {
      targetTile: {
        key: 'home.newMembers.metricTileTooltip.targetTile',
        defaultValue: 'Target for new members for selected period',
      },
      recruitedCustomersTile: {
        key: 'home.newMembers.metricTileTooltip.recruitedCustomersTile',
        defaultValue: 'Number of customers who joined the H&M Membership program during the selected period.',
      },
      recruitedShareTile: {
        key: 'home.newMembers.metricTileTooltip.recruitedShareTile',
        defaultValue: 'Percentage of total customers recruited as new H&M members during the selected period.',
      },
      totalUnrecruitedTile: {
        key: 'home.newMembers.metricTileTooltip.totalUnrecruitedTile',
        defaultValue: 'Number of customers who made purchases without being recruited as H&M members.',
      },
    },
  },
  piecesPerReceipt: {
    title: {
      key: 'home.piecesPerReceipt.title',
      defaultValue: 'Pieces per receipt',
    },
    subTitle: {
      key: 'home.piecesPerReceipt.subTitle',
      defaultValue: 'Pieces Sold per Receipt',
    },
    error: {
      key: 'home.piecesPerReceipt.error',
      defaultValue: 'We can´t show the pieces per receipt widget right now.',
    },
    toolTip: {
      key: 'home.piecesPerReceipt.toolTip',
      defaultValue: 'Sold Pieces per receipt in store',
    },
    headerText: {
      key: 'home.piecesPerReceipt.headerText',
      defaultValue: 'Pieces/Receipt',
    },
    currentPeriodTooltip: {
      key: 'home.piecesPerReceipt.currentPeriodTooltip',
      defaultValue: 'Average sold pieces (No of sold pieces - return pieces) per receipt for selected period',
    },
    lastWeekTooltip: {
      key: 'home.piecesPerReceipt.lastWeekTooltip',
      defaultValue:
        'Sold pieces (No of sold pieces - return pieces) per receipt during the same period last week.{{changeNote}}',
    },
    lastYearTooltip: {
      key: 'home.piecesPerReceipt.lastYearTooltip',
      defaultValue:
        'Sold pieces (No of sold pieces - return pieces) per receipt during the same period last year.{{changeNote}}',
    },
  },
  averagePurchase: {
    title: {
      key: 'home.averagePurchase.title',
      defaultValue: 'Average Purchase',
    },
    subTitle: {
      key: 'home.averagePurchase.subTitle',
      defaultValue: 'Sales Net per Receipt ',
    },
    error: {
      key: 'home.averagePurchase.error',
      defaultValue: 'We can´t show the average purchase widget right now.',
    },
    toolTip: {
      key: 'home.averagePurchase.toolTip',
      defaultValue: 'Sales Net per Receipt',
    },
    currentPeriodTooltip: {
      key: 'home.averagePurchase.currentPeriodTooltip',
      defaultValue: 'Average Net sale per receipt for selected period',
    },
    lastWeekTooltip: {
      key: 'home.averagePurchase.lastWeekTooltip',
      defaultValue: 'Net sale per receipt during the same period last week.{{changeNote}}',
    },
    lastYearTooltip: {
      key: 'home.averagePurchase.lastYearTooltip',
      defaultValue: 'Net sale per receipt during the same period last year.{{changeNote}}',
    },
  },
  shareOfReceipts: {
    title: {
      key: 'home.shareOfReceipts.title',
      defaultValue: 'Member Share Of Receipts',
    },
    subTitle: {
      key: 'home.shareOfReceipts.subTitle',
      defaultValue: 'SoRs for ',
    },
    error: {
      key: 'home.shareOfReceipts.error',
      defaultValue: 'We can´t show the member share of receipts widget right now.',
    },
    sor: {
      key: 'home.shareOfReceipts.sor',
      defaultValue: 'Share of receipts',
    },
    toolTip: {
      key: 'home.shareOfReceipts.toolTip',
      defaultValue: 'Percentage of total receipts generated by members.',
    },
    totalMemberTransactions: {
      key: 'home.shareOfReceipts.totalMemberTransactions',
      defaultValue: 'Total Member Transactions',
    },
    totalShareOfReceipts: {
      key: 'home.shareOfReceipts.totalShareOfReceipts',
      defaultValue: 'Total Share Of Receipts',
    },
    metricTileTooltip: {
      targetTile: {
        key: 'home.shareOfReceipts.metricTileTooltip.targetTile',
        defaultValue: 'Target for member share of receipts for selected period',
      },
      totalShareOfReceiptsTile: {
        key: 'home.shareOfReceipts.metricTileTooltip.totalShareOfReceiptsTile',
        defaultValue: 'Percentage of receipts generated by H&M members during the selected period.',
      },
      totalMemberTransactionsTile: {
        key: 'home.shareOfReceipts.metricTileTooltip.totalMemberTransactionsTile',
        defaultValue: 'Number of transactions completed by H&M members during the selected period.',
      },
    },
  },
  scoShareOfReceipts: {
    title: {
      key: 'home.scoShareOfReceipts.title',
      defaultValue: 'SCO - Share of Receipts',
    },
    subTitle: {
      key: 'home.scoShareOfReceipts.subTitle',
      defaultValue: 'SCO SoRs for ',
    },
    error: {
      key: 'home.scoShareOfReceipts.error',
      defaultValue: 'We can´t show the SCO share of receipts widget right now.',
    },
    sor: {
      key: 'home.scoShareOfReceipts.sor',
      defaultValue: 'SCO Share of receipts',
    },
    toolTip: {
      key: 'home.scoShareOfReceipts.toolTip',
      defaultValue: 'Share of Receipts for the SCO transactions. The Forecast is shown in percentage.',
    },
    totalSCOTransactions: {
      key: 'home.scoShareOfReceipts.totalSCOTransactions',
      defaultValue: 'Total SCO Transactions',
    },
    totalShareOfReceipts: {
      key: 'home.scoShareOfReceipts.totalShareOfReceipts',
      defaultValue: 'SCO Share Of Receipts',
    },
    metricTileTooltip: {
      targetTile: {
        key: 'home.scoShareOfReceipts.metricTileTooltip.targetTile',
        defaultValue: 'Target for SCO share of receipts for selected period',
      },
      totalShareOfReceiptsTile: {
        key: 'home.scoShareOfReceipts.metricTileTooltip.totalShareOfReceiptsTile',
        defaultValue: 'Percentage of total receipts generated through Self-Checkout during the selected period.',
      },
      totalSCOTransactionsTile: {
        key: 'home.scoShareOfReceipts.metricTileTooltip.totalSCOTransactionsTile',
        defaultValue: 'Number of transactions completed through Self-Checkout during the selected period.',
      },
    },
  },
  queueLength: {
    title: {
      key: 'home.queueLength.title',
      defaultValue: 'Queue Length',
    },
    subTitle: {
      key: 'home.queueLength.subTitle',
      defaultValue: 'Till queue count',
    },
    error: {
      key: 'home.queueLength.error',
      defaultValue: 'We can´t show the queue lenght widget right now.',
    },
    noData: {
      key: 'home.queueLength.noData',
      defaultValue: 'No Queues - Keep up the good work.',
    },
    toolTip: {
      key: 'home.queueLength.toolTip',
      defaultValue: 'Counts how often two receipts occur within < 30 seconds, showing when a till has a queue.',
    },
    chartToolTip: {
      key: 'home.queueLength.chartToolTip',
      defaultValue: 'Overall Queue Length and Experience',
    },
    tillToolTip: {
      key: 'home.queueLength.tillToolTip',
      defaultValue: 'Till',
    },
    tillVsTime: {
      key: 'home.queueLength.tillVsTime',
      defaultValue: 'Till/Time',
    },
    tabDefault: {
      key: 'home.queueLength.tabDefault',
      defaultValue: 'Regular Tills',
    },
    tabSelfCheckout: {
      key: 'home.queueLength.tabSelfCheckout',
      defaultValue: 'Self-service Checkout',
    },
    overallQueueLength: {
      key: 'home.queueLength.overallQueueLength',
      defaultValue: 'Overall Queue Length',
    },
    overallExperience: {
      key: 'home.queueLength.overallExperience',
      defaultValue: 'Overall Experience',
    },
    tillId: {
      key: 'home.queueLength.tillId',
      defaultValue: 'Till ID',
    },
    noTills: {
      key: 'home.queueLength.noTills',
      defaultValue: 'No tills found!',
    },
    queueLengthTillView: {
      key: 'home.queueLength.queueLengthTillView',
      defaultValue: 'Queue Length Till View',
    },
    metricTileTooltip: {
      queueLengthTile: {
        key: 'home.queueLength.metricTileTooltip.queueLengthTile',
        defaultValue: 'Average queue length across all checkout channels during the selected period.',
      },
      targetTile: {
        key: 'home.queueLength.metricTileTooltip.targetTile',
        defaultValue: 'Target for queue length for selected period',
      },
      overallExperienceTile: {
        key: 'home.queueLength.metricTileTooltip.overallExperienceTile',
        defaultValue: 'Overall checkout experience score for the selected period.',
      },
      regularTillsTile: {
        key: 'home.queueLength.metricTileTooltip.regularTillsTile',
        defaultValue: 'Queue length at staffed checkouts for the selected period.',
      },
      selfCheckoutTile: {
        key: 'home.queueLength.metricTileTooltip.selfCheckoutTile',
        defaultValue: 'Queue length at self-service checkouts for the selected period.',
      },
    },
  },
  appCustomers: {
    title: {
      key: 'home.appCustomers.title',
      defaultValue: 'App Customers',
    },
    subTitle: {
      key: 'home.appCustomers.subTitle',
      defaultValue: 'App-based Customers',
    },
    toolTip: {
      key: 'home.appCustomers.toolTip',
      defaultValue:
        'Customer who shopped in a store and made at least one H&M app purchase in the last 12 months.',
    },
    error: {
      key: 'home.appCustomers.error',
      defaultValue: 'We can´t show the app customers widget right now.',
    },
    newCustomersText: {
      key: 'home.appCustomers.newCustomersText',
      defaultValue: 'New App Customers',
    },
    newAppCustomerSubtext: {
      key: 'home.appCustomers.newAppCustomerSubtext',
      defaultValue: 'Customers made their first app purchase (during the past 12 months) in the selected week.',
    },
    appCustomerText: {
      key: 'home.appCustomers.appCustomerText',
      defaultValue: 'App Customer',
    },
    activeCustomersText: {
      key: 'home.appCustomers.activeCustomersText',
      defaultValue: 'Active Customers',
    },
    activeCustomersTooltip: {
      key: 'home.appCustomers.activeCustomersTooltip',
      defaultValue: 'Customers who purchased in a store within 12 months',
    },
    appAchieversText: {
      key: 'home.appCustomers.appAchieversText',
      defaultValue: 'App Achievers',
    },
    currentWeekNote: {
      key: 'home.appCustomers.currentWeekNote',
      defaultValue: `Current week will show last week's data.`,
    },
    tooltips: {
      appAchieversTooltip: {
        key: 'home.appCustomers.tooltips.appAchieversTooltip',
        defaultValue: 'Customers who made their first app purchase during the selected week.',
      },
      appCustomersTooltip: {
        key: 'home.appCustomers.tooltips.appCustomersTooltip',
        defaultValue: 'Customers who made at least one app purchase in the last 12 months.',
      },
      activeCustomersTooltip: {
        key: 'home.appCustomers.tooltips.activeCustomersTooltip',
        defaultValue: 'H&M Member customers with at least one store purchase in the last 12 months.',
      },
      appCustomerTooltip: {
        key: 'home.appCustomers.tooltips.appCustomerTooltip',
        defaultValue: 'Total H&M Member customers associated with the selected store.',
      },
    },
  },
  rfidCount: {
    title: {
      key: 'home.rfidCount.title',
      defaultValue: 'RFID Count',
    },
    subTitle: {
      key: 'home.rfidCount.subTitle',
      defaultValue: 'Counts, Time Spent, and Scanners',
    },
    toolTip: {
      key: 'home.rfidCount.toolTip',
      defaultValue: 'Displays total counts, time spent, and scanners used.',
    },
    error: {
      key: 'home.rfidCount.error',
      defaultValue: "We can't show the RFID Count widget right now.",
    },
    countText: {
      title: {
        key: 'home.rfidCount.countText.title',
        defaultValue: 'Counts',
      },
      subTitle: {
        key: 'home.rfidCount.countText.subTitle',
        defaultValue: 'Total inventory counted. Values below 0 indicate immediate discrepancies.',
      },
    },
    timeText: {
      title: {
        key: 'home.rfidCount.timeText.title',
        defaultValue: 'Time Spent',
      },
      subTitle: {
        key: 'home.rfidCount.timeText.subTitle',
        defaultValue: 'Calculate total hours and average time spent for comprehensive time analysis.',
      },
    },
    scannerText: {
      title: {
        key: 'home.rfidCount.scannerText.title',
        defaultValue: 'Devices used',
      },
      subTitle: {
        key: 'home.rfidCount.scannerText.subTitle',
        defaultValue: 'Shows a warning if fewer than 2 devices are used (minimum of 2 required).',
      },
      tooltip: {
        key: 'home.rfidCount.scannerText.tooltip',
        defaultValue: 'No of scanners used for inventory count',
      },
    },
  },
  stockAccuracy: {
    title: {
      key: 'home.stockAccuracy.title',
      defaultValue: 'Stock Accuracy',
    },
    subTitle: {
      key: 'home.stockAccuracy.subTitle',
      defaultValue: 'Accuracy by Difference Type',
    },
    error: {
      key: 'home.stockAccuracy.error',
      defaultValue: 'We can´t show the stock accuracy widget right now.',
    },
    toolTip: {
      key: 'home.stockAccuracy.toolTip',
      defaultValue:
        'Breakdown of inventory accuracy based on SAP quantities, including overstock, understock, and open order discrepancies.',
    },
    noData: {
      key: 'home.stockAccuracy.noData',
      defaultValue: 'No stock accuracy data found.',
    },
    openOrders: {
      key: 'home.stockAccuracy.openOrders',
      defaultValue: 'Open Orders',
    },
    accuracyText: {
      key: 'home.stockAccuracy.accuracyText',
      defaultValue: 'Percentage of accurate stock compared to SAP quantities.',
    },
    positiveDifferenceText: {
      key: 'home.stockAccuracy.positiveDifferenceText',
      defaultValue: 'Percentage of counted stock exceeding SAP stock quantity.',
    },
    negativeDifferenceText: {
      key: 'home.stockAccuracy.negativeDifferenceText',
      defaultValue: 'Percentage of counted stock below SAP stock quantity.',
    },
    openOrderText: {
      key: 'home.stockAccuracy.openOrderText',
      defaultValue: 'Percentage of positive differences caused by open orders.',
    },
    accuracy: {
      key: 'home.stockAccuracy.accuracy',
      defaultValue: 'Accuracy',
    },
    weeklyViewText: {
      key: 'home.stockAccuracy.weeklyViewText',
      defaultValue: 'Weekly view for stock accuracy',
    },
    showDetails: {
      key: 'home.stockAccuracy.showDetails',
      defaultValue: 'Show Details',
    },
    dropdownTooltip: {
      key: 'home.stockAccuracy.dropdownTooltip',
      defaultValue: 'No details for daily/weekly view available.',
    },
    negativeApprovalRateTooltip: {
      key: 'home.stockAccuracy.negativeApprovalRateTooltip',
      defaultValue: 'Percentage of negative differences that are approved.',
    },
  },
  helpASale: {
    title: {
      key: 'home.helpASale.title',
      defaultValue: 'Help-A-Sale',
    },
    subTitle: {
      key: 'home.helpASale.subTitle',
      defaultValue: 'Help-A-Sale Analytics',
    },
    error: {
      key: 'home.helpASale.error',
      defaultValue: "We can't show the help a sale widget right now.",
    },
    toolTip: {
      key: 'home.helpASale.toolTip',
      defaultValue:
        'HAS helps staff locate products or suitable alternatives and request them directly on the shop floor. This widget tracks usage and conversion from Help a Sale lookups and estimates their contribution to overall store sales uplift.',
    },
    hasCountText: {
      key: 'home.helpASale.hasCountText',
      defaultValue: 'Customer facing HaS product lookups',
    },
    hasCountDescription: {
      key: 'home.helpASale.hasCountDescription',
      defaultValue: 'No of Help-A-Sale usages with customer',
    },
    hasPerVisitorsText: {
      key: 'home.helpASale.hasPerVisitorsText',
      defaultValue: 'Customer facing HaS product lookups/visitor',
    },
    conversionText: {
      key: 'home.helpASale.conversionText',
      defaultValue: 'Conversion HaS product Lookups',
    },
    upliftText: {
      key: 'home.helpASale.upliftText',
      defaultValue: 'Uplift',
    },
    graphNotAvailableText: {
      key: 'home.helpASale.graphNotAvailableText',
      defaultValue:
        'The graph is not available for the daily view. Please select weekly or monthly view to see the graph.',
    },
    upliftTooltipText: {
      key: 'home.helpASale.upliftTooltipText',
      defaultValue: 'Estimated sales uplift generated from Help-A-Sale product lookups.',
    },
    upliftSalesTooltipText: {
      key: 'home.helpASale.upliftSalesTooltipText',
      defaultValue: 'Total sales value associated with Help-A-Sale interactions during the selected period.',
    },
    conversionPercentageTooltipText: {
      key: 'home.helpASale.conversionPercentageTooltipText',
      defaultValue: 'Percentage of Help-A-Sale lookups that resulted in a purchase.',
    },
    customerFacingLookupsTooltipText: {
      key: 'home.helpASale.customerFacingLookupsTooltipText',
      defaultValue: 'Total customer-assisted product lookups using Help-A-Sale during the selected period.',
    },
    customerFacingLookupsPerVisitorTooltipText: {
      key: 'home.helpASale.customerFacingLookupsPerVisitorTooltipText',
      defaultValue: 'Average Help-A-Sale product lookups relative to store visitors during the selected period.',
    },
  },
  bopis: {
    title: {
      key: 'home.bopis.title',
      defaultValue: 'BOPIS',
    },
    subTitle: {
      key: 'home.bopis.subTitle',
      defaultValue: 'Buy Online, Pickup In Store',
    },
    error: {
      key: 'home.bopis.error',
      defaultValue: "We can't show the BOPIS widget right now.",
    },
    noDataText: {
      key: 'home.bopis.noDataText',
      defaultValue: 'No BOPIS orders found.',
    },
    toolTip: {
      key: 'home.bopis.toolTip',
      defaultValue:
        'This widget displays total orders, split into pending and processed categories, with detailed breakdowns by fulfillment status such as not started, picked, fulfilled, and cancelled.',
    },
    totalOrdersTitle: {
      key: 'home.bopis.totalOrdersTitle',
      defaultValue: 'Total Orders',
    },
    totalOrdersSubTitle: {
      key: 'home.bopis.totalOrdersSubTitle',
      defaultValue: 'All BOPIS Orders',
    },
    totalOrdersFootnote: {
      key: 'home.bopis.totalOrdersFootnote',
      defaultValue: '100% of All Orders',
    },
    pendingOrdersTitle: {
      key: 'home.bopis.pendingOrdersTitle',
      defaultValue: 'Pending Orders',
    },
    processesOrdersTitle: {
      key: 'home.bopis.processesOrdersTitle',
      defaultValue: 'Processed Orders',
    },
    shareOfOrders: {
      key: 'home.bopis.shareOfOrders',
      defaultValue: 'of {{totalCount}} orders',
    },
    statusNotStarted: {
      key: 'home.bopis.statusNotStarted',
      defaultValue: 'Not Started',
    },
    statusFullyPicked: {
      key: 'home.bopis.statusFullyPicked',
      defaultValue: 'Fully Picked',
    },
    statusPartiallyPicked: {
      key: 'home.bopis.statusPartiallyPicked',
      defaultValue: 'Partially Picked',
    },
    statusCancelled: {
      key: 'home.bopis.statusCancelled',
      defaultValue: 'Cancelled',
    },
    statusZeroPicked: {
      key: 'home.bopis.statusZeroPicked',
      defaultValue: 'Zero Pickup',
    },
    statusFullyFulfilled: {
      key: 'home.bopis.statusFullyFulfilled',
      defaultValue: 'Fully Fulfilled',
    },
    statusPartiallyFulfilled: {
      key: 'home.bopis.statusPartiallyFulfilled',
      defaultValue: 'Partially Fulfilled',
    },
    tabBopisOrdersName: {
      key: 'home.bopis.tabBopisOrdersName',
      defaultValue: 'BOPIS Orders',
    },
    tabOverviewName: {
      key: 'home.bopis.tabOverviewName',
      defaultValue: 'Overview',
    },
    overviewBopisSales: {
      key: 'home.bopis.overviewBopisSales',
      defaultValue: 'BOPIS Sales',
    },
    overviewShareOfBusiness: {
      key: 'home.bopis.overviewShareOfBusiness',
      defaultValue: 'Share Of Business',
    },
    overviewUpsellingAmount: {
      key: 'home.bopis.overviewConversionRate',
      defaultValue: 'Upselling Amount',
    },
    overviewConversionRate: {
      key: 'home.bopis.overviewConversionRate',
      defaultValue: 'Conversion Rate',
    },
    bopisSalesTooltipText: {
      key: 'home.bopis.bopisSalesTooltipText',
      defaultValue: 'Net sales value from picked BOPIS orders during the selected period.',
    },
    shareOfBusinessTooltipText: {
      key: 'home.bopis.shareOfBusinessTooltipText',
      defaultValue: 'BOPIS sales as a percentage of total store sales during the selected period.',
    },
    upsellingAmountTooltipText: {
      key: 'home.bopis.upsellingAmountTooltipText',
      defaultValue: 'Additional sales generated by converted BOPIS loyalty customers during the selected period.',
    },
    conversionRateTooltipText: {
      key: 'home.bopis.conversionRateTooltipText',
      defaultValue: 'Percentage of BOPIS loyalty customers who completed a purchase during the selected period.',
    },
    fullyFulfilledTooltipText: {
      key: 'home.bopis.fullyFulfilledTooltipText',
      defaultValue: 'Orders completely picked and ready during the selected period.',
    },
    partiallyFulfilledTooltipText: {
      key: 'home.bopis.partiallyFulfilledTooltipText',
      defaultValue: 'Orders partially picked due to unavailable items during the selected period.',
    },
    cancelledTooltipText: {
      key: 'home.bopis.cancelledTooltipText',
      defaultValue: 'Orders cancelled during the selected period.',
    },
    zeroPickedTooltipText: {
      key: 'home.bopis.zeroPickedTooltipText',
      defaultValue: 'Orders with no items picked during the selected period.',
    },
  },
  bopisLeadTime: {
    title: {
      key: 'home.bopisLeadTime.title',
      defaultValue: 'BOPIS Lead Time Overview',
    },
    subTitle: {
      key: 'home.bopisLeadTime.subTitle',
      defaultValue: 'Compliance/ Lead Time KPIs',
    },
    error: {
      key: 'home.bopisLeadTime.error',
      defaultValue: "We can't show the BOPIS Lead Time widget right now.",
    },
    toolTip: {
      key: 'home.bopisLeadTime.toolTip',
      defaultValue:
        'Displays key metrics for Buy Online, Pick Up In Store performance, including turnaround time, customer promise adherence and picking/packing efficiency. Track trends to identify delays and threshold breaches.',
    },
    customerPromise: {
      key: 'home.bopisLeadTime.customerPromise',
      defaultValue: 'Customer Promise',
    },
    customerPromiseTooltipText: {
      key: 'home.bopisLeadTime.customerPromiseTooltipText',
      defaultValue: 'Orders completed within 4 hours as a percentage of total processed orders.',
    },
    turnaroundTime: {
      key: 'home.bopisLeadTime.turnaroundTime',
      defaultValue: 'Turnaround Time',
    },
    turnaroundTimeTooltipText: {
      key: 'home.bopisLeadTime.turnaroundTimeTooltipText',
      defaultValue: 'Average time from order creation to customer notification during the selected period.',
    },
    aboveThreshold: {
      key: 'home.bopisLeadTime.aboveThreshold',
      defaultValue: 'Above Threshold',
    },
    aboveThresholdTooltipText: {
      key: 'home.bopisLeadTime.aboveThresholdTooltipText',
      defaultValue: 'Average pick and pack time exceeded the 7-minute target during the selected period.',
    },
    pickPlusPackMinutes: {
      key: 'home.bopisLeadTime.pickPlusPackMinutes',
      defaultValue: 'Pick + Pack Minutes',
    },
    pickMinutesPackMinutesTooltipText: {
      key: 'home.bopisLeadTime.pickMinutesPackMinutesTooltipText',
      defaultValue: `Pick Minutes: Average time spent picking orders during the selected period. \n Pack Minutes: Average time spent packing orders during the selected period.`,
    },
    totalLeadTime: {
      key: 'home.bopisLeadTime.totalLeadTime',
      defaultValue: 'Total Lead Time',
    },
    pickText: {
      key: 'home.bopisLeadTime.pickText',
      defaultValue: 'Pick',
    },
    packText: {
      key: 'home.bopisLeadTime.packText',
      defaultValue: 'Pack',
    },
    totalText: {
      key: 'home.bopisLeadTime.totalText',
      defaultValue: 'Total',
    },
    graphNoDataText: {
      key: 'home.bopisLeadTime.graphNoDataText',
      defaultValue:
        'The graph is not available for the daily view. Please select weekly or monthly view to see the graph.',
    },
  },
  customerFeedback: {
    title: {
      key: 'home.customerFeedback.title',
      defaultValue: 'Customer Satisfaction',
    },
    subTitle: {
      key: 'home.customerFeedback.subTitle',
      defaultValue: 'CSAT Summary',
    },
    toolTip: {
      key: 'home.customerFeedback.toolTip',
      defaultValue:
        'Customer satisfaction measures how happy customers are with their recent in‑store shopping experience.',
    },
    error: {
      key: 'home.customerFeedback.error',
      defaultValue: 'We can´t show the customer feedback widget right now.',
    },
    customerResponses: {
      key: 'home.customerFeedback.customerResponses',
      defaultValue: 'Customer Responses',
    },
    viewAllResponses: {
      key: 'home.customerFeedback.viewAllResponses',
      defaultValue: 'View All Responses',
    },
    modalHeaders: {
      key: 'home.customerFeedback.modalHeaders',
      defaultValue: 'Customer responses',
    },
    modalSubHeaders: {
      key: 'home.customerFeedback.modalSubHeaders',
      defaultValue: 'View All Customer Response',
    },
    totalResponse: {
      key: 'home.customerFeedback.totalResponse',
      defaultValue: 'Total Response',
    },
    filterBy: {
      key: 'home.customerFeedback.filterBy',
      defaultValue: 'Filter By: ',
    },
    noData: {
      key: 'home.customerFeedback.noData',
      defaultValue: 'No customer feedback available yet.',
    },
  },
  customerEngagement: {
    title: {
      key: 'home.customerEngagement.title',
      defaultValue: 'Customer Engagement',
    },
    subTitle: {
      key: 'home.customerEngagement.subTitle',
      defaultValue: 'Customer Assistance Analytics',
    },
    toolTip: {
      key: 'home.customerEngagement.toolTip',
      defaultValue:
        'This widget provides insights into customer engagement and staff-assisted interactions, including member recruitment, identification, article lookups, and overall engagement success rates, tracked via the INSC app.',
    },
    error: {
      key: 'home.customerEngagement.error',
      defaultValue: 'We can´t show the customer engagement widget right now.',
    },
    nodataText: {
      key: 'home.customerEngagement.nodataText',
      defaultValue: 'No customers assisted yet!.',
    },
    customerEngaged: {
      key: 'home.customerEngagement.customerEngaged',
      defaultValue: 'Customer Engaged',
    },
    storeTraffic: {
      key: 'home.customerEngagement.storeTraffic',
      defaultValue: 'Store Traffic',
    },
    memberRecruited: {
      key: 'home.customerEngagement.memberRecruited',
      defaultValue: 'Member Recruited',
    },
    recruitment: {
      key: 'home.customerEngagement.recruitment',
      defaultValue: 'Recruitment',
    },
    ratio: {
      key: 'home.customerEngagement.ratio',
      defaultValue: 'Ratio',
    },
    memberIdentification: {
      key: 'home.customerEngagement.memberIdentification',
      defaultValue: 'Member Identification',
    },
    membersIdentified: {
      key: 'home.customerEngagement.membersIdentified',
      defaultValue: 'Members Identified',
    },
    memberPurchases: {
      key: 'home.customerEngagement.memberPurchases',
      defaultValue: 'Member Purchases',
    },
    conversionRate: {
      key: 'home.customerEngagement.conversionRate',
      defaultValue: 'Conversion Rate',
    },
    articleLookups: {
      key: 'home.customerEngagement.articleLookups',
      defaultValue: 'Article Lookups',
    },
    lookups: {
      key: 'home.customerEngagement.lookups',
      defaultValue: 'Lookups',
    },
    purchasedArticles: {
      key: 'home.customerEngagement.purchasedArticles',
      defaultValue: 'Purchased Articles',
    },
    storeTrafficTooltip: {
      key: 'home.customerEngagement.storeTrafficTooltip',
      defaultValue: 'Footfall in stores - Traffic data is from EXA',
    },
    memberRecruitedTooltip: {
      key: 'home.customerEngagement.memberRecruitedTooltip',
      defaultValue: `Recruitment = New H&M Member Recruited
INSC App Recruitment = Number of customers provided Email via Member Sign Up in inStore Care App
Ratio = INSC App Recruitment / Recruitment`,
    },
    memberIdentificationTooltip: {
      key: 'home.customerEngagement.memberIdentificationTooltip',
      defaultValue: `Members Identified = Number of existing members identified via Member info
Member Purchases = Members who were identified and made purchase on the same day. 
Success Rate = Members Purchases / Members Identified`,
    },
    articleLookupsTooltip: {
      key: 'home.customerEngagement.articleLookupsTooltip',
      defaultValue: `Lookups = Number of customers assisted with Omni information (no identification needed) 
Purchased Articles = Sum of  No. of  the article sold where the article was lookup by the INSC app
Lookup success rate = Purchased Articles / Total Lookup Attempts`,
    },
    customerEngagementPercentageTooltip: {
      key: 'home.customerEngagement.customerEngagementPercentageTooltip',
      defaultValue:
        'Percentage of store visitors engaged through in-store customer assistance during the selected period.',
    },
    totalCustomerEngagedTooltip: {
      key: 'home.customerEngagement.totalCustomerEngagedTooltip',
      defaultValue: 'Total customers supported with In Store Care App (INSC)',
    },
  },
  areaComparison: {
    title: {
      key: 'home.areaComparison.title',
      defaultValue: 'Area Comparison',
    },
    subTitle: {
      key: 'home.areaComparison.subTitle',
      defaultValue: 'Weekly and Annual Data with Area',
    },
    toolTip: {
      key: 'home.areaComparison.toolTip',
      defaultValue: 'Target comparisons between stores in the area.',
    },
    error: {
      key: 'home.areaComparison.error',
      defaultValue: 'We can´t show the area comparison widget right now.',
    },
    taktCurrentDateMessage: {
      key: 'home.areaComparison.taktCurrentDateMessage',
      defaultValue: 'We will not show Takt for the current dates',
    },
    equationGroup: {
      sales: {
        key: 'home.areaComparison.equationGroup.sales',
        defaultValue: 'Sales',
      },
      salesEquation: {
        key: 'home.areaComparison.equationGroup.salesEquation',
        defaultValue: 'Sales Equation',
      },
      efficiency: {
        key: 'home.areaComparison.equationGroup.efficiency',
        defaultValue: 'Efficiency',
      },
    },
  },
  rfidSalesRetagging: {
    title: {
      key: 'home.rfidSalesRetagging.title',
      defaultValue: 'RFID Sales',
    },
    subTitle: {
      key: 'home.rfidSalesRetagging.subTitle',
      defaultValue: 'Added Sales and Retagging',
    },
    tooltip: {
      key: 'home.rfidSalesRetagging.tooltip',
      defaultValue:
        'Shows the set sales target percentage and retagging compliance, where 100% indicates optimal performance.',
    },
    error: {
      key: 'home.rfidSalesRetagging.error',
      defaultValue: `We can't show the RFID Sales widget right now.`,
    },
    noData: {
      key: 'home.rfidSalesRetagging.noData',
      defaultValue: 'No RFID sales and retagging.',
    },
    addedSalesTitle: {
      key: 'home.rfidSalesRetagging.addedSalesTitle',
      defaultValue: 'Added Sales',
    },
    addedSalesDescription: {
      key: 'home.rfidSalesRetagging.addedSalesDescription',
      defaultValue:
        'Indicates the targeted percentage increase in sales, helping to evaluate business growth against set sales goals.',
    },
    retaggingRateTitle: {
      key: 'home.rfidSalesRetagging.retaggingRateTitle',
      defaultValue: 'Retagging Rate',
    },
    retaggingRateDescription: {
      key: 'home.rfidSalesRetagging.retaggingRateDescription',
      defaultValue: 'Percentage of inventory correctly retagged; 100% indicates complete compliance',
    },
    totalSuccessfulRetaggingTitle: {
      key: 'home.rfidSalesRetagging.totalSuccessfulRetaggingTitle',
      defaultValue: 'Successful Retagging',
    },
    totalSuccessfulRetaggingDescription: {
      key: 'home.rfidSalesRetagging.totalSuccessfulRetaggingDescription',
      defaultValue: 'Total number of items successfully retagged across all transactions.',
    },
  },
  rfidApprovals: {
    title: {
      key: 'home.rfidApprovals.title',
      defaultValue: 'RFID Differences',
    },
    subTitle: {
      key: 'home.rfidApprovals.subTitle',
      defaultValue: 'Inventory Discrepancy and Adjustment',
    },
    tooltip: {
      key: 'home.rfidApprovals.toolTip',
      defaultValue:
        'Displays the difference between actual and expected inventory counts, indicating potential shortages (negative) or overstock (positive).',
    },
    error: {
      key: 'home.rfidApprovals.error',
      defaultValue: `We can't show the RFID approvals widget right now.`,
    },
    noData: {
      key: 'home.rfidApprovals.noData',
      defaultValue: 'No RFID approvals data available.',
    },
    negativeTitle: {
      key: 'home.rfidApprovals.negativeTitle',
      defaultValue: 'Negative Difference',
    },
    negativeDescription: {
      key: 'home.rfidApprovals.negativeDescription',
      defaultValue:
        'Indicates the number of inventory items missing compared to the expected count, highlighting potential loss or shortages.',
    },
    positiveTitle: {
      key: 'home.rfidApprovals.positiveTitle',
      defaultValue: 'Positive Difference',
    },
    positiveDescription: {
      key: 'home.rfidApprovals.positiveDescription',
      defaultValue:
        'Indicates the number of additional inventory items found beyond expectations, suggesting possible overstock or inventory miscounts.',
    },
    breakdown: {
      key: 'home.rfidApprovals.breakdown',
      defaultValue: 'Non Approved Pieces / Total Stock Qty',
    },
    breakdownWeekly: {
      key: 'home.rfidApprovals.breakdownWeekly',
      defaultValue: 'Non Approved Pieces / Number of counts',
    },
    approvalRate: {
      key: 'home.rfidApprovals.approvalRate',
      defaultValue: 'Approval Rate',
    },
    approvedPiecesTooltip: {
      key: 'home.rfidApprovals.approvedPiecesTooltip',
      defaultValue: 'Approved Pieces',
    },
    nonApprovedPiecesTooltip: {
      key: 'home.rfidApprovals.nonApprovedPiecesTooltip',
      defaultValue: 'Non Approved Pieces',
    },
  },
  salesInsightWidget: {
    title: {
      key: 'home.salesInsightWidget.title',
      defaultValue: 'Sales Insights',
    },
    subTitle: {
      key: 'home.salesInsightWidget.subTitle',
      defaultValue: 'Performance, Customers, Items',
    },
    tooltip: {
      key: 'home.salesInsightWidget.tooltip',
      defaultValue:
        'Tracks hourly sales, customers, and items sold, highlighting trends in performance, customer engagement, and sales efficiency for better decision-making',
    },
    error: {
      key: 'home.salesInsightWidget.error',
      defaultValue: "We can't show the sales insight widget right now.",
    },
    includeVatText: {
      key: 'home.salesInsightWidget.includeVatText',
      defaultValue: 'Includes VAT',
    },
    metrics: {
      sales: {
        key: 'home.salesInsightWidget.metrics.sales',
        defaultValue: 'Sales ({{currency}})',
      },
      salesByTotal: {
        key: 'home.salesInsightWidget.metrics.salesByTotal',
        defaultValue: 'Sales/Total (%)',
      },
      customers: {
        key: 'home.salesInsightWidget.metrics.customers',
        defaultValue: 'Customers (#)',
      },
      customersByTotal: {
        key: 'home.salesInsightWidget.metrics.customersByTotal',
        defaultValue: 'Customers/Total (%)',
      },
      salesByCustomer: {
        key: 'home.salesInsightWidget.metrics.salesByCustomer',
        defaultValue: 'Sales/Customer ({{currency}})',
      },
      itemsSold: {
        key: 'home.salesInsightWidget.metrics.itemsSold',
        defaultValue: 'Items Sold (#)',
      },
      itemsSoldByCustomer: {
        key: 'home.salesInsightWidget.metrics.itemsSoldByCustomer',
        defaultValue: 'Items Sold/Customer (#)',
      },
    },
    metricTooltips: {
      sales: {
        key: 'home.salesInsightWidget.metricTooltips.sales',
        defaultValue: 'Total Net sales for selected period',
      },
      salesByTotal: {
        key: 'home.salesInsightWidget.metricTooltips.salesByTotal',
        defaultValue: 'Percentage of sales in relation to the total sales.',
      },
      customers: {
        key: 'home.salesInsightWidget.metricTooltips.customers',
        defaultValue: 'Number of total customers',
      },
      customersByTotal: {
        key: 'home.salesInsightWidget.metricTooltips.customersByTotal',
        defaultValue: 'Percentage of customers in relation to the total number of customers',
      },
      salesByCustomer: {
        key: 'home.salesInsightWidget.metricTooltips.salesByCustomer',
        defaultValue: 'Amount of sales per customer (not affected by returns).',
      },
      itemsSold: {
        key: 'home.salesInsightWidget.metricTooltips.itemsSold',
        defaultValue: 'Number of items sold in selected period',
      },
      itemsSoldByCustomer: {
        key: 'home.salesInsightWidget.metricTooltips.itemsSoldByCustomer',
        defaultValue: 'Number of items sold per customer for the specific time unit',
      },
    },
  },
  efficiencyWidget: {
    title: {
      key: 'home.efficiencyWidget.title',
      defaultValue: 'Efficiency',
    },
    subTitle: {
      key: 'home.efficiencyWidget.subTitle',
      defaultValue: 'Sales, Productivity & Efficiency',
    },
    tooltip: {
      key: 'home.efficiencyWidget.tooltip',
      defaultValue:
        'This widget tracks sales, sold pieces, and labor hours to measure productivity and time efficiency.',
    },
    error: {
      key: 'home.efficiencyWidget.error',
      defaultValue: "We can't show the efficiency widget right now.",
    },
    noData: {
      key: 'home.efficiencyWidget.noData',
      defaultValue: 'No data available as Effective hours is 0.',
    },
    takt1: {
      title: {
        key: 'home.efficiencyWidget.takt1.title',
        defaultValue: 'Takt1',
      },
      text: {
        key: 'home.efficiencyWidget.takt1.text',
        defaultValue:
          'Sales net per effective hour, measuring productivity and efficiency (Sales Net / Effective Hours)',
      },
      budget: {
        key: 'home.efficiencyWidget.takt1.budget',
        defaultValue: 'Show Takt1 Budget/Plan',
      },
    },
    spt: {
      title: {
        key: 'home.efficiencyWidget.spt.title',
        defaultValue: 'SPT',
      },
      text: {
        key: 'home.efficiencyWidget.spt.text',
        defaultValue:
          'Sold pieces per effective hour, measuring efficiency in terms of sold units (Sold Pieces / Effective Hours)',
      },
      budget: {
        key: 'home.efficiencyWidget.spt.budget',
        defaultValue: 'Show SPT Budget/Plan',
      },
    },
    effectiveHours: {
      title: {
        key: 'home.efficiencyWidget.effectiveHours.title',
        defaultValue: 'Effective Hours',
      },
      text: {
        key: 'home.efficiencyWidget.effectiveHours.text',
        defaultValue: 'Total labor hours invested (excluding vacations, illness or other absences). ​',
      },
      budget: {
        key: 'home.efficiencyWidget.effectiveHours.budget',
        defaultValue: 'Show Effective Hours Budget/Plan',
      },
    },
    tooltips: {
      lastWeekTakt1: {
        key: 'home.efficiencyWidget.tooltips.lastWeekTakt1',
        defaultValue: 'Takt1 for the same period last week.{{changeNote}}',
      },
      lastYearTakt1: {
        key: 'home.efficiencyWidget.tooltips.lastYearTakt1',
        defaultValue: 'Takt1 for the same period last year.{{changeNote}}',
      },
      lastWeekSPT: {
        key: 'home.efficiencyWidget.tooltips.lastWeekSPT',
        defaultValue: 'SPT for the same period last week.{{changeNote}}',
      },
      lastYearSPT: {
        key: 'home.efficiencyWidget.tooltips.lastYearSPT',
        defaultValue: 'SPT for the same period last year.{{changeNote}}',
      },
      lastWeekEffectiveHours: {
        key: 'home.efficiencyWidget.tooltips.lastWeekEffectiveHours',
        defaultValue: 'Effective hours for the same period last week.{{changeNote}}',
      },
      lastYearEffectiveHours: {
        key: 'home.efficiencyWidget.tooltips.lastYearEffectiveHours',
        defaultValue: 'Effective hours for the same period last year.{{changeNote}}',
      },
    },
  },
  widgetCategory: {
    allWidgets: {
      key: 'home.widgetCategory.allWidgets',
      defaultValue: 'All Widgets',
    },
    highlightedWidgets: {
      key: 'home.widgetCategory.highlightedWidgets',
      defaultValue: 'Highlighted Widgets',
    },
    salesEfficiency: {
      key: 'home.widgetCategory.salesEfficiency',
      defaultValue: 'Sales & Efficiency',
    },
    customerBaseValue: {
      key: 'home.widgetCategory.customerBaseValue',
      defaultValue: 'Customer Base Value',
    },
    customerExperience: {
      key: 'home.widgetCategory.customerExperience',
      defaultValue: 'Customer Experience',
    },
    transactions: {
      key: 'home.widgetCategory.transactions',
      defaultValue: 'Transactions',
    },
    overviewWidgets: {
      key: 'home.widgetCategory.overviewWidgets',
      defaultValue: 'Overview Widgets',
    },
    noteText: {
      key: 'home.widgetCategory.noteText',
      defaultValue: 'Note: You do not have permission to edit widget settings',
    },
  },
  kpiTargets: {
    addKpi: {
      key: 'home.kpiTargets.addKpi',
      defaultValue: 'Add KPI',
    },
    editKpi: {
      key: 'home.kpiTargets.editKpi',
      defaultValue: 'Edit KPI',
    },
    addkpiForNMShare: {
      key: 'home.kpiTargets.addkpiForNMShare',
      defaultValue: 'Add KPI for NM Share',
    },
    editkpiForNMShare: {
      key: 'home.kpiTargets.editkpiForNMShare',
      defaultValue: 'Edit KPI for NM Share',
    },
    addkpiForSOR: {
      key: 'home.kpiTargets.addkpiForSOR',
      defaultValue: 'Add KPI for SOR',
    },
    editkpiForSOR: {
      key: 'home.kpiTargets.editkpiForSOR',
      defaultValue: 'Edit KPI for SOR',
    },
    editAreaCap: {
      key: 'home.kpiTargets.editAreaCap',
      defaultValue: 'Edit Area Cap',
    },
    labelText: {
      key: 'home.kpiTargets.labelText',
      defaultValue: 'Enter {{modalType}} value for {{widgetName}}',
    },
    removeLabelText: {
      key: 'home.kpiTargets.removeLabelText',
      defaultValue: 'Are you sure you want to remove {{modalType}} for {{widgetName}}?',
    },
    errorHelperText1: {
      key: 'home.kpiTargets.errorHelperText1',
      defaultValue: 'No special characters or alphabets are allowed!',
    },
    errorHelperText2: {
      key: 'home.kpiTargets.errorHelperText2',
      defaultValue: '{{modalType}} value cannot be more than 10 digits',
    },
    errorHelperText3: {
      key: 'home.kpiTargets.errorHelperText3',
      defaultValue: '{{modalType}} value cannot be more than 100',
    },
    errorHelperText4: {
      key: 'home.kpiTargets.errorHelperText4',
      defaultValue: 'This field is required!',
    },
    errorHelperText5: {
      key: 'home.kpiTargets.errorHelperText5',
      defaultValue: 'Value cannot be 0. You can choose to remove target instead',
    },
    errorHelperText6: {
      key: 'home.kpiTargets.errorHelperText6',
      defaultValue: 'Decimal places cannot be more than 2',
    },
    successText: {
      key: 'home.kpiTargets.successText',
      defaultValue: 'The {{modalType}} for {{widgetName}} widget has been {{operation}} successfully.',
    },
    errorText: {
      key: 'home.kpiTargets.errorText',
      defaultValue: 'The {{modalType}} could not be updated. Please try again!',
    },
    disabledTooltip: {
      key: 'home.kpiTargets.disabledTooltip',
      defaultValue: 'No receipts created to add/edit KPI',
    },
    previousDayTooltip: {
      key: 'home.kpiTargets.previousDayTooltip',
      defaultValue: 'You cannot add/edit KPI for the previous day',
    },
    noPermissionTooltip: {
      key: 'home.kpiTargets.noPermissionTooltip',
      defaultValue: 'You do not have permission to edit/add KPI',
    },
    lockedTargetTooltip: {
      key: 'home.kpiTargets.lockedTargetTooltip',
      defaultValue: 'Target is locked!',
    },
    note: {
      key: 'home.kpiTargets.note',
      defaultValue: ' Note: Editing Area Cap will affect all stores in the area',
    },
  },
  celebrationModal: {
    title: {
      key: 'home.celebrationModal.title',
      defaultValue: 'Congratulations!',
    },
    subtitleForSingle: {
      key: 'home.celebrationModal.subtitleForSingle',
      defaultValue: 'You have achieved target of {{widgetName}} on {{date}}',
    },
    subtitleForMultiple: {
      key: 'home.celebrationModal.subtitleForMultiple',
      defaultValue: 'You have achieved the following targets on {{date}} \n {{widgetName}}',
    },
    widgetName: {
      key: 'home.celebrationModal.widgetName',
      defaultValue: '{{widgetName}} : {{targetValue}}',
    },
  },
  highlight: {
    title: {
      key: 'home.highlight.title',
      defaultValue: 'Highlight',
    },
  },
  settingsPermissions: {
    personalSettings: {
      key: 'home.settingsPermissions.personalSettings',
      defaultValue: 'Personal Settings',
    },
    kpiTargets: {
      key: 'home.settingsPermissions.kpiTargets',
      defaultValue: 'KPI Targets',
    },
    areaCaps: {
      key: 'home.settingsPermissions.areaCaps',
      defaultValue: 'Area Caps',
    },
    lockTargets: {
      key: 'home.settingsPermissions.lockTargets',
      defaultValue: 'Lock Targets',
    },
    financialPlanned: {
      key: 'home.settingsPermissions.financialPlanned',
      defaultValue: 'Financial Planned',
    },
    financialBudget: {
      key: 'home.settingsPermissions.financialBudget',
      defaultValue: 'Financial Budget',
    },
    appCustomers: {
      key: 'home.settingsPermissions.appCustomers',
      defaultValue: 'App Customers',
    },
    employeePermissions: {
      key: 'home.settingsPermissions.employeePermissions',
      defaultValue: 'Employee Permissions',
    },
    blacklistPermissionsForArea: {
      key: 'home.settingsPermissions.blacklistPermissionsForArea',
      defaultValue: 'Blacklist Permissions for Area',
    },
    currencyConverter: {
      key: 'home.settingsPermissions.currencyConverter',
      defaultValue: 'Currency Converter',
    },
  },
};
